import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {orangeColors} from '../../layouts/theme/designSystem';

export const ChatBasedTalentSurveyPageHeader = () => {
  const {t} = useTranslation();

  return (
    <Box sx={{textAlign: 'center', pt: 2}}>
      <Typography
        variant='h1'
        component='h1'
        gutterBottom
        sx={{
          fontSize: {xs: '36px', md: '48px', lg: '64px'},
          fontWeight: 700,
          lineHeight: '115%',
          color: '#000',
        }}
      >
        {t('talents.chatBasedSurvey.pageTitlePrefix')}
        <Box component='span' sx={{color: orangeColors[900]}}>
          {t('talents.chatBasedSurvey.pageTitleHighlight')}
        </Box>
      </Typography>
      <Typography variant='h4' component='p' sx={{textTransform: 'uppercase', fontWeight: 500, mb: 1}}>
        {t('talents.chatBasedSurvey.pageSubtitle')}
      </Typography>
      <Typography variant='body1' sx={{maxWidth: 600, mx: 'auto'}}>
        {t('talents.chatBasedSurvey.pageDescription')}
      </Typography>
    </Box>
  );
};
